var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconesBranco12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.39,
    y: 8.49,
    className: "st0",
    width: 35.51,
    height: 2.97
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.39,
    y: 16.19,
    className: "st0",
    width: 35.51,
    height: 2.97
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.88,
    y: 44.19,
    className: "st0",
    width: 19.39,
    height: 3.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.88,
    y: 39.27,
    className: "st0",
    width: 19.39,
    height: 3.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.88,
    y: 49.12,
    className: "st0",
    width: 19.39,
    height: 3.16
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "35.64,39.36 35.64,44.29 30.71,44.29 30.71,47.25 35.64,47.25 35.64,52.19 38.61,52.19 38.61,47.25  43.54,47.25 43.54,44.29 38.61,44.29 38.61,39.36  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.39,
    y: 25.1,
    className: "st0",
    width: 7.29,
    height: 2.97
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.12,0.39 9.12,28.07 14.17,28.07 14.17,25.1 12.09,25.1 12.09,3.35 56.64,3.35 56.64,25.1  25.91,25.1 25.91,28.07 59.61,28.07 59.61,0.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0.39,59.61 5.66,59.61 5.66,56.65 3.36,56.65 3.36,34.9 47.91,34.9 47.91,56.65 17.4,56.65  17.4,59.61 50.88,59.61 50.88,31.93 0.39,31.93  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.88,
    y: 56.65,
    className: "st0",
    width: 7.29,
    height: 2.97
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconesBranco12);
export default __webpack_public_path__ + "static/media/Icones_Branco-12.ccf80c00f8d9723f7ce2bce7d4ca7f6a.svg";
export { ForwardRef as ReactComponent };